import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Box, Card, CardContent, Typography, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { GoogleLoginButton } from "@/components/GoogleLoginButton";
import { LocaleAndThemeToolbar } from "@/components/LocaleAndThemeToolbar";

export default function Login() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showAuthError, setShowAuthError] = useState(false);

  useEffect(() => {
    if (searchParams.get("error") !== "auth_failed") return;
    setShowAuthError(true);
    const next = new URLSearchParams(searchParams);
    next.delete("error");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
        }}
      >
        <LocaleAndThemeToolbar variant="page" />
      </Box>
      <Card sx={{ width: { xs: "90%", sm: 400 }, p: 2 }} elevation={4}>
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              textAlign: "center",
              mb: 1,
            }}
          >
            {t("app.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              mb: 3,
            }}
          >
            {t("auth.loginSubtitle")}
          </Typography>
          {showAuthError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {t("auth.authFailed")}
            </Alert>
          )}
          <GoogleLoginButton />
        </CardContent>
      </Card>
    </Box>
  );
}
